<template>
  <component :is="receiptData === undefined ? 'div' : 'b-card'">
    <b-alert variant="danger" :show="receiptData === undefined">
      <h4 class="alert-heading">獲取收據數據時出錯</h4>
      <div class="alert-body">
        找不到相關收據記錄。請查看
        <b-link class="alert-link" :to="{ name: 'receipts-list' }">
          收據列表
        </b-link>
      </div>
    </b-alert>
    <receipt-edit-tab-information
      v-if="receiptData"
      :invoice-options="invoiceOptions"
      :project-options="projectOptions"
      :customer-options="customerOptions"
      :payment-method-options="paymentMethodOptions"
      :receipt-remark-options="receiptRemarkOptions"
      :template-options="templateOptions"
      :stamp-options="stampOptions"
      :receipt-data="receiptData"
      :receipt-description-options="receiptDescriptionOptions"
      :receipt-document-description-options="receiptDocumentDescriptionOptions"
      class="p-sm-2"
      @refetch-data="
        router.currentRoute.query.invoice_id ? fetchInvoice() : refetchData()
      "
    />
  </component>
</template>

<script>
import { BCard, BAlert, BLink, BTabs, BTab } from "bootstrap-vue";
import { ref, onUnmounted, onMounted, nextTick } from "@vue/composition-api";
import store from "@/store";
import router from "@/router";
import receiptStoreModule from "../receiptStoreModule";
import receiptEditTabInformation from "./receiptEditTabInformation.vue";

export default {
  components: {
    receiptEditTabInformation,
    BCard,
    BAlert,
    BTabs,
    BTab,
    BLink,
  },
  setup() {
    const receiptData = ref({ 
      id: 0,
      stamp_id: null,
      template_id: 1,
      remark_id: 3,
      customer_id: null,
      name_cn: "",
      name_en: "",
      mobile: "",
      email: "",
      project_id: null,
      project_name: "",
      address: "",
      receipt_items: [
        {
          id: 0,
          invoice_id: null,
          amount: null,
          payment_date: null,
          item_description: null,
          is_deposit: 0,
          payment_method_id: null,
        },
      ],
      receipt_date: new Date().toISOString().substr(0, 10),
    });
    const receipt = {
      id: 0,
      stamp_id: null,
      template_id: 1,
      remark_id:  3,
      customer_id: null,
      name_cn: "",
      name_en: "",
      mobile: "",
      email: "",
      project_id: null,
      project_name: "",
      address: "",
      receipt_remark: null,
      remark: null,
      receipt_items: [
        {
          id: 0,
          invoice_id: null,
          amount: null,
          payment_date: null,
          item_description: null,
          is_deposit: 0,
          payment_method_id: null,
        },
      ],
      receipt_date: new Date().toISOString().substr(0, 10),
    };

    const receipt_APP_STORE_MODULE_NAME = "receipt";

    if (!store.hasModule(receipt_APP_STORE_MODULE_NAME))
      store.registerModule(receipt_APP_STORE_MODULE_NAME, receiptStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(receipt_APP_STORE_MODULE_NAME))
        store.unregisterModule(receipt_APP_STORE_MODULE_NAME);
    });

    const refetchData = () => {

      if (router.currentRoute.name == "receipt-create") {

        if (router.currentRoute.query.invoice_id) {
          // 初始化由發票生成收據的數據
          var obj = {
            ...receipt,
            ...{
              customer_id: invoiceData.value.customer_id,
              name_cn: invoiceData.value.name_cn,
              name_en: invoiceData.value.name_en,
              mobile: invoiceData.value.mobile,
              email: invoiceData.value.email,
              project_id: invoiceData.value.project_id,
              project_name: invoiceData.value.project_name,
              address: invoiceData.value.address,
              ...{
                receipt_items:[
                  {
                    id: 0,
                    invoice_id: invoiceData.value.id,
                    payment_date: new Date().toISOString().substr(0, 10),
                    amount:0,
                    is_deposit:0, 
                    payment_method_id:null

                  },
                ]
              }
            }
          };
          receiptData.value = obj
            
        } else {
           // 初始化收據的數據
          receiptData.value = receipt;
          
          // 處理來自客戶列表的客戶ID query參數
          if (router.currentRoute.query.customer_id) {
            receiptData.value.customer_id = parseInt(router.currentRoute.query.customer_id);
          }
          
          // 安全地設定備註內容
          if (receiptRemarkOptions.value && receiptRemarkOptions.value.length > 0) {
            const foundRemark = receiptRemarkOptions.value.find(
              (ele) => ele.id == receiptData.value.remark_id
            );
            if (foundRemark && foundRemark.content) {
              receiptData.value.receipt_remark = foundRemark.content;
            }
          }
        }
      } else {
         // 初始化fetch已有收據的數據
        store
          .dispatch("receipt/fetchReceipt", {
            id: router.currentRoute.params.id,
          })
          .then((response) => {
            receiptData.value = response.data.receipt;
          })
          .catch((error) => {
            console.log("error when fetching receipt", error);
            if (error.response.status === 404) {
              receiptData.value = undefined;
            }
          });
      }
    };

    const invoiceData = ref(null);
    const fetchInvoice = () => {
      if (router.currentRoute.query.invoice_id) {
        store
          .dispatch("receipt/fetchInvoice", {
            id: router.currentRoute.query.invoice_id,
          })
          .then((response) => {
            invoiceData.value = response.data.invoice;

            console.log("fetchInvoice 完整回應:", response.data);
            console.log("發票數據:", response.data.invoice);

            // 修復：將載入的發票添加到 invoiceOptions 中，確保收據編輯頁面能正確顯示發票資訊
            if (response.data.invoice) {
              const invoice = response.data.invoice;

              // 檢查付款階段數據
              console.log("發票付款階段數據:", {
                paymentSteps: invoice.paymentSteps,
                payment_steps: invoice.payment_steps,
                paymentStepsLength: (invoice.paymentSteps || []).length,
                payment_stepsLength: (invoice.payment_steps || []).length
              });

              // **修復：不要預先格式化 invoice_number，讓 v-select 的模板來處理格式化**
              // 保持原始的發票編號，讓收據編輯頁面的模板來格式化顯示
              // 確保必要的欄位存在
              if (!invoice.amount && invoice.total_amount) {
                invoice.amount = invoice.total_amount;
              }
              if (!invoice.total_paid) {
                invoice.total_paid = 0;
              }

              // 將發票添加到選項中（保持原始數據結構）
              invoiceOptions.value = [invoice];
              console.log("已將發票添加到 invoiceOptions（保持原始格式）:", invoice);
            }

            refetchData();
          })
          .catch((error) => {
            console.log("error when fetching receipt", error);
            if (error.response.status === 404) {
              receiptData.value = undefined;
            }
          });
      }
    };

    const receiptDescriptionOptions = ref([]);
    const receiptDocumentDescriptionOptions = ref([]);
    const invoiceOptions = ref([]);
    const customerOptions = ref([]);
    const projectOptions = ref([]);
    const paymentMethodOptions = ref([]);
    const receiptRemarkOptions = ref([]);
    const templateOptions = ref([]);
    const stampOptions = ref([]);

    const refetchOption = () => {
      store
        .dispatch("app/fetchOptionList", {
          invoices: true,
          projects: true,
          customers: true,
          receive_methods: true,
          receipt_remarks: true,
          templates: true,
          stamps: true,
          receipt_descriptions: true,
          receipt_document_descriptions: true,
        })
        .then((response) => {
          console.log("fetchOptionList response:", response.data);
          invoiceOptions.value = response.data.invoices;
          projectOptions.value = response.data.projects;
          customerOptions.value = response.data.customers;
          paymentMethodOptions.value = response.data.receive_methods.sort ((a, b) => a.sort_order - b.sort_order);
          receiptRemarkOptions.value = response.data.receipt_remarks;
          templateOptions.value = response.data.templates;
          stampOptions.value = response.data.stamps;
          receiptDescriptionOptions.value = response.data.receipt_descriptions;
          receiptDocumentDescriptionOptions.value = response.data.receipt_document_descriptions;
          console.log("receiptDescriptionOptions:", receiptDescriptionOptions.value);
          console.log("receiptDocumentDescriptionOptions:", receiptDocumentDescriptionOptions.value);
          if (router.currentRoute.query.invoice_id) {
            fetchInvoice();
          } else {
            refetchData();
          }
        });
    };

    onMounted(() => {
      refetchOption();
    });

    return {
      invoiceOptions,
      projectOptions,
      customerOptions,
      paymentMethodOptions,
      templateOptions,
      stampOptions,
      receiptRemarkOptions,
      receiptData,
      refetchData,
      refetchOption,
      fetchInvoice,
      receiptDescriptionOptions,
      receiptDocumentDescriptionOptions,
    };
  },
};
</script>
